RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const companyDisplay = RivalIQ.utils.companyDisplay;

    views.PostAlert = views.Alert.extend({
        ui: {
            post: '.x-post',
            likelyPromoted: '.likely-promoted-text'
        },
        template: '#alertsPostAlertTemplate',
        getPostMessage: function () {
            const me = this;
            const post = me.model.get('data');
            return post.rivaliq.display.message || post.rivaliq.display.linkTitle;
        },
        getCdnKey: function () {
            const me = this;
            const post = me.model.get('data');
            const sources = RivalIQ.enums.sources;
            if (post.source === sources.FACEBOOK) {
                return post.native_id;
            } else if (post.source === sources.INSTAGRAM) {
                const postLink = post.rivaliq.display.postLink;
                const shortcode = postLink ? postLink.split('/')[4].split('?')[0] : '';
                return `${shortcode}?postNativeId=${post.native_id}`;
            }
            return false;
        },
        getChannel: function () {
            const me = this;
            const post = me.model.get('data');
            return _.get(RivalIQ.enums.sourceDetails, [post.source, 'channel'], '');
        },
        getPostImageUrl: function () {
            const me = this;
            const post = me.model.get('data');
            return post.rivaliq.display.image;
        },
        getPostNativeUrl: function () {
            const me = this;
            const post = me.model.get('data');
            return post.rivaliq.display.postLink;
        },
        getPostSourceName: function () {
            const me = this;
            const post = me.model.get('data');
            const sourceDetails = RivalIQ.enums.sourceDetails[post.source];
            const sourceName = sourceDetails.name;
            return sourceName;
        },
        getPostPresenceImageUrl: function () {
            const me = this;
            const company = me.getCompany();
            const post = me.model.get('data');
            const sourceDetails = RivalIQ.enums.sourceDetails[post.source];
            const presenceIconUrl = companyDisplay.getChannelPresenceIcon(sourceDetails.channel, company.attributes,
                post.presence_native_id);
            return presenceIconUrl;
        },
        getPostEngagementPercent: function () {
            const me = this;
            const post = me.model.get('data');
            return post.engagement_rate;
        },
        getPostEngagementTotal: function () {
            const me = this;
            const post = me.model.get('data');
            return post.engagement_total;
        },
        hasFixedPostEngagementRate: function () {
            const me = this;
            const engagementRate = me.getPostEngagementPercent();
            return (engagementRate > 9);
        },
        getEngagementProperties: function () {
            const me = this;
            const post = me.model.get('data');
            const sourceDetails = RivalIQ.enums.sourceDetails[post.source];
            return _.map(sourceDetails.engagementTypeMappings, function (mapping) {
                return {
                    property: mapping.name,
                    name: mapping.displayName
                };
            });
        },
        getIsBoosted: function () {
            const me = this;
            const post = me.model.get('data');
            return RivalIQ.state.account.get('plan').has_likely_promoted &&
                   (_.includes(RivalIQ.utils.companyEvents.eventClass.alertsLikelyBoostedPosts.members, me.model.get('event_type_id')) ||
                   (post.promoted_likelyhood && post.promoted_likelyhood >= RivalIQ.enums.likelyPromoted.threshold));
        },
        getAlertIconClassName: function () {
            const me = this;
            const post = me.model.get('data');
            const sourceDetails = RivalIQ.enums.sourceDetails[post.source];
            return sourceDetails.fontIcon;
        },
        augmentTemplateData: function (data) {
            const me = this;

            views.Alert.prototype.augmentTemplateData.apply(me, arguments);

            data.postMessage = me.getPostMessage();
            data.postImageUrl = me.getPostImageUrl();
            data.cdnKey = me.getCdnKey();
            data.channel = me.getChannel();
            data.postNativeUrl = me.getPostNativeUrl();
            data.postSourceName = me.getPostSourceName();
            data.postEngagementPercent = me.getPostEngagementPercent();
            data.postEngagementTotal = me.getPostEngagementTotal();
            data.postPresenceImageUrl = me.getPostPresenceImageUrl();
            data.engagementProperties = me.getEngagementProperties();
            data.absolutePercent = RivalIQ.formatter.absolutePercent;
            data.isBoosted = me.getIsBoosted();
            data.likelyPromotedDescription = RivalIQ.strings.likely_promoted_description;

            const timezone = me.getProp('timezone');
            const formattedPublishedAt = `${RivalIQ.utils.timezone.getDateInTimezone(timezone, data.data.published_at).format('MMM D, YYYY LT')
            } ${moment.tz(data.data.published_at, timezone).zoneName()}`;
            data.formattedPublishedAt = formattedPublishedAt;
        },
        onRender: function () {
            const me = this;
            const additionalClassNames = me.getPostAdditionalClassNames();

            if (additionalClassNames) {
                me.ui.post.addClass(additionalClassNames);
            }
        },
        onBeforeShow: function () {
            const me = this;
            me.ui.likelyPromoted.popover();
        },
        getPostAdditionalClassNames: function () {
            const me = this;
            let className = null;
            const postImageUrl = me.getPostImageUrl();

            if (!postImageUrl) {
                className = 'x-text-only';
            }

            return className;
        }
    });

}, window.moment);
